import type { FC } from 'react';

import { InkeepChat } from './InkeepChat';
import { useInkeepChatEnabled } from './useInkeepChatEnabled';

// Gated out here rather than inside InkeepChat so the widget's config hook — and the
// widget-settings request it makes — never runs for users who won't see it.
export const ChatIntegration: FC = () => (useInkeepChatEnabled() ? <InkeepChat /> : null);
